// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".active-cat[data-v-af5bb1fc] .v-card{background-color:#0d8ddc;color:#fff}.active-cat[data-v-af5bb1fc] span{color:#0d8ddc}", ""]);
// Exports
module.exports = exports;
